import apiClient from "api/apiBase";
import type { AxiosResponse } from "axios";
import type {
  ApiResponse,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  SignInRequest,
  SignUpRequest,
  UserDataResponse,
} from "./auth.types";

export class AuthApi {
  async signUp(data: SignUpRequest): Promise<AxiosResponse<void>> {
    return apiClient.post("/api/register", data);
  }

  async signIn(data: SignInRequest): Promise<AxiosResponse<void>> {
    return apiClient.post("/api/login", data);
  }

  async forgotPassword(data: ForgotPasswordRequest): Promise<AxiosResponse<ApiResponse>> {
    return apiClient.post("/api/forgot-password", data);
  }

  async resetPassword(data: ResetPasswordRequest): Promise<AxiosResponse<ApiResponse>> {
    return apiClient.post("/api/reset-password", data);
  }

  async getUser(): Promise<UserDataResponse> {
    return await apiClient.get("/api/user/me");
  }
}

export const authApi = new AuthApi();
